import React from 'react';
import { Card, Input, InputNumber, Select, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

interface FilterPanelProps {
  year: number;
  month: number;
  deptFrom: string;
  deptTo: string;
  deptFromName: string;
  deptToName: string;
  loading: boolean;
  onYearChange: (v: number) => void;
  onMonthChange: (v: number) => void;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onDeptFromBlur: () => void;
  onDeptToBlur: () => void;
  onQuery: () => void;
  onReset: () => void;
}

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: `${String(i + 1).padStart(2, '0')} 月`,
}));

const FilterPanel: React.FC<FilterPanelProps> = React.memo(({
  year, month, deptFrom, deptTo, deptFromName, deptToName, loading,
  onYearChange, onMonthChange, onDeptFromChange, onDeptToChange,
  onDeptFromBlur, onDeptToBlur, onQuery, onReset,
}) => {
  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle" align="end">
        {/* Year-Month Selection */}
        <div>
          <label className="p9315-filter-label">年度月份</label>
          <Space size="small">
            <InputNumber
              value={year}
              onChange={v => onYearChange(v ?? new Date().getFullYear())}
              min={1990}
              max={2099}
              style={{ width: 100 }}
            />
            <span>年</span>
            <Select
              value={month}
              onChange={onMonthChange}
              options={monthOptions}
              style={{ width: 100 }}
            />
          </Space>
        </div>

        {/* Department Code Range */}
        <div>
          <label className="p9315-filter-label">部門 [從]</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Input
              value={deptFrom}
              onChange={e => onDeptFromChange(e.target.value)}
              onBlur={onDeptFromBlur}
              placeholder="起始部門"
              style={{ width: 100 }}
              allowClear
            />
            {deptFromName && <span className="p9315-lookup-name">{deptFromName}</span>}
          </div>
        </div>
        <div>
          <label className="p9315-filter-label">[至]</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Input
              value={deptTo}
              onChange={e => onDeptToChange(e.target.value)}
              onBlur={onDeptToBlur}
              placeholder="結束部門"
              style={{ width: 100 }}
              allowClear
            />
            {deptToName && <span className="p9315-lookup-name">{deptToName}</span>}
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
          <Space>
            <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
              查詢
            </Button>
            <Button icon={<ClearOutlined />} onClick={onReset}>
              清除
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  );
});

FilterPanel.displayName = 'FilterPanel';

export default FilterPanel;
